// removed by extract-text-webpack-plugin
module.exports = {"fourohfour":"_3wdiP35nOJ-bp7ziAB15NI_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-rewriter.js?id=data-v-1218a0d0!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/404.vue
// module id = 57
// module chunks = 2